import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Scale, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LAWYER_BASE } from "@lawyer/constants/route";

export default function LawyerLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || LAWYER_BASE;

  useEffect(() => {
    if (loading || !user) return;
    if (user.role === "lawyer") navigate(from, { replace: true });
    else navigate("/", { replace: true });
  }, [user, loading, navigate, from]);

  return (
    <div className="min-h-screen bg-[#0A2540] grid place-items-center p-6">
      <div className="max-w-md w-full bg-white rounded-3xl p-8 shadow-2xl" data-testid="lawyer-login-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-12 w-12 rounded-xl bg-[#D4AF37] grid place-items-center text-[#0A2540]">
            <Scale size={22} />
          </div>
          <div>
            <p className="text-xl font-extrabold text-[#0A2540]" style={{ fontFamily: "Poppins" }}>Advoset Pro</p>
            <p className="text-[11px] uppercase tracking-widest text-slate-400 font-bold">Partner Portal</p>
          </div>
        </div>

        <h1 className="text-2xl font-extrabold text-[#0A2540]" style={{ fontFamily: "Poppins" }}>Welcome back, advocate</h1>
        <p className="mt-2 text-sm text-slate-500">
          Sign in with your registered email or phone. Only verified lawyers can access this portal.
        </p>

        <Button
          onClick={login}
          data-testid="lawyer-login-btn"
          className="mt-6 w-full rounded-xl adv-btn-primary font-bold h-11"
        >
          <Scale size={16} /> Sign in to your practice
        </Button>

        <p className="mt-5 text-[11px] text-slate-400 inline-flex items-center gap-1">
          <Lock size={12} /> Secure session · Audit logged
        </p>
        <p className="mt-3 text-[11px] text-slate-500">
          New here? Apply at <a href="/lawyers/join" className="font-bold text-[#0A2540] underline">advoset.in/lawyers/join</a> to start onboarding.
        </p>
      </div>
    </div>
  );
}
